var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-mt-6 gl-flex gl-justify-center"},[_c('gl-keyset-pagination',_vm._g(_vm._b({on:{"prev":function($event){return _vm.onPrev($event)},"next":function($event){return _vm.onNext($event)}}},'gl-keyset-pagination',_vm.pageInfo,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }